import React from 'react';
export const Footer = () => {
  return <div className="w-full bg-green-800 py-8 text-gray-200 text-sm" data-id="element-54">
      <div className="max-w-6xl mx-auto px-4 md:px-8" data-id="element-55">
        <p className="text-center mb-4" data-id="element-56">
          These statements have not been evaluated by the FDA. This product is
          not intended to diagnose, treat, cure, or prevent any disease.
        </p>
        <div className="flex justify-center space-x-6 mb-4" data-id="element-57">
          <a href="#" className="hover:text-white" data-id="element-58">
            Privacy Policy
          </a>
          <a href="#" className="hover:text-white" data-id="element-59">
            Terms of Service
          </a>
          <a href="#" className="hover:text-white" data-id="element-60">
            Contact Us
          </a>
        </div>
        <p className="text-center" data-id="element-61">
          © {new Date().getFullYear()} Snouty & Co. All rights reserved.
        </p>
      </div>
    </div>;
};